var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row px-1 px-md-0", attrs: { id: "mentions" } },
    [
      _c(
        "LinkFoldUnFold",
        {
          attrs: {
            "button-id": "legal-mentions-toggle",
            "button-label": _vm.title,
            "collapsed-block-id": "legal-mentions-content",
            "is-collapsed": false,
            "is-large": "",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "font-size-resp-12",
              attrs: {
                id: "legal-mentions-content",
                "aria-labelledby": "mention-legal",
              },
            },
            _vm._l(_vm.legalMentions, function (legalMention, index) {
              return _c(
                "div",
                {
                  key: "legal-mention-content-" + index,
                  staticClass: "col-12 pb-2",
                },
                [
                  _c("div", {
                    directives: [
                      {
                        name: "msh-html",
                        rawName: "v-msh-html",
                        value: legalMention.text,
                        expression: "legalMention.text",
                      },
                    ],
                  }),
                ]
              )
            }),
            0
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }